<script setup lang="ts">
import { chairPositionLabel } from '../../services/chairLabel';
import type { ChairListItemDto } from '../../types/chair';

/**
 * Presentational list of one user's own chairs (docs/tasks/022-journal.md část 1) — shared by
 * ChairGate.vue (mandatory, no cancel) and ChairSwitcherDialog.vue (voluntary, has cancel).
 */
defineProps<{
  chairs: ChairListItemDto[];
  currentChairId: number | null;
}>();

const emit = defineEmits<{ pick: [chairId: number] }>();
</script>

<template>
  <div v-if="!chairs.length" class="text-danger">
    Nemáte přiřazenou žádnou pozici, kontaktujte administrátora.
  </div>
  <ul v-else class="list-unstyled">
    <li v-for="c of chairs" :key="c.chair.id" class="mb-2">
      <button
          type="button"
          class="btn btn-outline-secondary"
          :class="{ active: c.chair.id === currentChairId }"
          @click="emit('pick', c.chair.id)"
      >{{ chairPositionLabel(c) }}</button>
    </li>
  </ul>
</template>
